import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { translate, TranslocoService } from '@ngneat/transloco';

declare var require: any;
declare var $: any;


@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

  billing:any;
  email = "";

  tab = "plan";
  
  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) {

  }

  ngOnInit(): void {

    if(this.okService.billing){

      this.getSetup();

    }else{
      let self = this;
      setTimeout(function(){
        self.getSetup();
      }, 2000);
    }

  }

  getSetup(){

    if(this.okService.billing.contract_signing && this.okService.billing.contract_signing.uses_new_contract_system && this.okService.billing.contract_signing.signining_required){
      this.tab = "signup";
    }

    if(!this.okService.billing.live){
      
      this.router.navigateByUrl('/account/trial');
          

    }else{

      this.getBilling();

    }
  }

  getBilling(){
    this.okService.get("billing",{'expand':'invoices'})
    .subscribe((data:any) => {

      this.billing = data.body;

      //console.log(this.billing);

    })
  }


  deleteEmail(email:string){
    this.okService.delete("billing/emailstatement",{email:email})
    .subscribe((data:any) => {

      //console.log(data.body);

      this.billing.plan.emails = data.body;

      this.okService.setAlert(this.transloco.translate("Your settings have been updated"),"success");

    });
  }

  addEmail(){

    if(this.email){
      this.okService.put("billing/emailstatement",{email:this.email})
      .subscribe((data:any) => {

        //console.log(data.body);

        this.billing.plan.emails = data.body;

        this.okService.setAlert(this.transloco.translate("Your settings have been updated"),"success");

      });
    }
  }



}
